import styled from 'styled-components';

/** Who sent the report, shown above the answers they gave. */
export const SummaryList = styled.dl`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 16px;
  margin: 0;
  font-size: 14px;

  dt {
    color: ${({ theme }) => theme.colors.gray['500']};
  }

  dd {
    margin: 0;
    font-weight: ${({ theme }) => theme.font.weight.semibold};
  }
`;

/**
 * The reason of a decision, inside the confirmation modal. It is uncontrolled
 * on purpose: the modal rebuilds its content on every render of the screen, so
 * keeping the value in the DOM is what lets the field survive typing.
 */
export const ReasonInput = styled.textarea`
  width: 100%;
  min-height: 96px;
  margin-top: 8px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.gray['300']};
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
`;

/** Label of the reason field inside the confirmation modal. */
export const ReasonLabel = styled.span`
  display: block;
  font-size: 14px;
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  text-align: left;
`;

/** Why the reason matters, for a rejection. */
export const ReasonHelp = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.5;
  text-align: left;
  color: ${({ theme }) => theme.colors.gray['500']};
`;

/** What the API answered when it refused the decision. */
export const ReasonError = styled.span`
  display: block;
  margin-top: 6px;
  font-size: 13px;
  text-align: left;
  color: ${({ theme }) => theme.colors.primaries.darker};
`;
